<div class="container">
  <div class="register-container">
    <div *ngIf="!successRegister" class="complete-profile card">
      <button type="button" class="btn-close login-close" aria-label="Close" (click)="closeLogin()"></button>
      <div class="header-title">
          <img class="login-img" src="../../../../assets/images/logo-header-shell.svg" alt="Logo">
          <h4>Completá tu registro</h4>
      </div>
      <form [formGroup]="completeRegister" class="register-form" novalidate>

        <div *ngIf="errorRegister" class="alert alert-warning p-2" role="alert">
          {{errorRegister}}
        </div>
        <div class="mt-3">
          <label for="register-documento" class="form-label">Número de Documento (sin puntos ni guiones)</label>
          <input type="number" id="register-documento" class="form-control register-form-input"
            placeholder="Ingresá tu número de documento" formControlName="document" readonly>
          <div *ngIf="completeRegister.get('document')?.invalid && completeRegister.get('document')?.touched"
            class="error-message">
            Número de documento inválido.
          </div>
        </div>        

        <div class="mt-3">
          <label for="register-nombre" class="form-label">Nombre</label>
          <input type="text" id="register-nombre" name="register-nombre" class="form-control register-form-input" placeholder="Ingresá tu nombre completo" formControlName="firstname"
          >
          <div *ngIf="completeRegister.get('firstname')?.invalid && completeRegister.get('firstname')?.touched" class="error-message">
            Este campo es obligatorio.
          </div>
        </div>
        
        <div class="mt-3">
          <label for="register-apellido" class="form-label">Apellido</label>
          <input type="text" id="register-apellido" name="register-apellido" class="form-control register-form-input" placeholder="Ingresa tu/s apellido/s" formControlName="lastname"
          >
          <div *ngIf="completeRegister.get('lastname')?.invalid && completeRegister.get('lastname')?.touched" class="error-message">
            Este campo es obligatorio.
          </div>
        </div>

        <div class="mt-3 cellphone">
          <div>
            <label for="register-cod-area" class="form-label">Cód. de área</label>
            <input type="text" maxlength="4" class="form-control register-form-input" id="register-cod-area"
              name="register-cod-area" placeholder="11" formControlName="areaCode">
          </div>
          <div>
            <label for="register-telefono" class="form-label">Número de teléfono</label>
            <input type="text" maxlength="10" class="form-control register-form-input" id="register-telefono"
              name="register-telefono" placeholder="Ingresá tu número de teléfono" formControlName="number">
          </div>
        </div>

        <div class="mt-3">
          <label for="register-email" class="form-label">Email</label>
          <input type="email" id="register-email" class="form-control register-form-input"
            placeholder="Ingresá tu correo electrónico" formControlName="email">
          <div *ngIf="completeRegister.get('email')?.invalid && completeRegister.get('email')?.touched"
            class="error-message">
            Email inválido.
          </div>
        </div>

        <div class="mt-3">
          <label for="register-password" class="form-label">Contraseña</label>
          <div class="wrap-password">
            <input [type]="showPassword1 ? 'text' : 'password'" id="register-password"
              class="form-control register-form-input" placeholder="Ingresá tu contraseña" formControlName="password">
            <span class="eye" [ngClass]="showPassword1 ? 'show' : ''" (click)="showPassword1 = !showPassword1"></span>
          </div>
          <div *ngIf="completeRegister.get('password')?.touched">
            <div *ngIf="!completeRegister.get('password')?.value && completeRegister.get('password')?.errors?.['required']">
              <small class="error-message">Este campo es obligatorio.</small>
            </div>        
            <div *ngIf="completeRegister.get('password')?.value && completeRegister.get('password')?.errors?.['minlength']">
              <small class="error-message">La contraseña debe tener al menos 8 caracteres.</small>
            </div>            
            <div *ngIf="completeRegister.get('password')?.value && completeRegister.get('password')?.errors?.['passwordComplexity']">
              <small class="error-message">La contraseña debe tener al menos 8 caracteres, una letra mayúscula, una letra minúscula, un número y un símbolo especial.</small>
            </div>
          </div>          
        </div>
        
        <div class="mt-3">
          <label for="register-check-password" class="form-label">Ingresá tu contraseña nuevamente</label>
          <div class="wrap-password">
            <input [type]="showPassword2 ? 'text' : 'password'" id="register-check-password"
              class="form-control register-form-input" placeholder="Repetí tu contraseña" formControlName="confirmPassword">
            <span class="eye" [ngClass]="showPassword2 ? 'show' : ''" (click)="showPassword2 = !showPassword2"></span>
          </div>
          <div *ngIf="completeRegister.get('confirmPassword')?.hasError('passwordMismatch') && completeRegister.get('confirmPassword')?.touched"
            class="error-message">Las contraseñas no coinciden.</div>
        </div>

        <div class="mt-3 checkTerms">
          <input type="checkbox" id="register_accept_terms_complete" data-gtm-id="register_accept_terms_complete" formControlName="tyc_shellbox_accepted">
          <label for="register_accept_terms_complete" class="form-label register-light">
            He leído y acepto los <a href="assets/terminos-y-condiciones.pdf" target="_blank">términos y condiciones</a>
          </label>
        </div>

        <div class="mt-3 checkTerms">
          <input type="checkbox" id="register_accept_terms_complete_market" data-gtm-id="register_accept_terms_complete_market" formControlName="tyc_marketshell_accepted">
          <label for="register_accept_terms_complete_market" class="form-label register-light">
            He leído y acepto los <a href="https://central-content.portal-movilidad.simplitec.io/assets/6f5eab68-778d-46b0-8a5c-8cc289daebce" target="_blank">términos y condiciones de Market Shell</a>
          </label>
        </div>

        <div class="mt-3 checkTerms">
          <input id="register-quiero-recibir-novedades" name="register-quiero-recibir-novedades" type="checkbox" value="1" formControlName="optin" />
          <label for="register-quiero-recibir-novedades" class="form-label register-light">Quiero recibir novedades y promociones de Shell Box</label>
        </div>

        <button [disabled]="completeRegister.invalid || registerIn" 
        class="btn btn-primary mt-3" 
        [ngClass]="registerIn ? 'loading' : ''" 
        (click)="nextStep()">
          <span *ngIf="registerIn" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span *ngIf="!registerIn">Completar registro</span>
        </button>
      </form>
    </div>
    <div *ngIf="successRegister" class="complete-profile card">
      <button type="button" class="btn-close login-close" aria-label="Close" (click)="closeLogin()"></button>
      <div class="register-form successContainer">
        <p class="title-step title-end-register mt-3">¡Registro Exitoso!</p>
        <p class="disclaimer-end-register">Ya casi terminamos ...</p>
        <div *ngIf="errorRegister" class="alert alert-warning p-2" role="alert">
          {{errorRegister}}
        </div>
        <div class="mt-3">
          <img src="assets/images/register-asset/laststep.png" style="width: 80%; margin-left: 10%;">
        </div>
        <div class="mt-3 text-center">
          Hemos enviado un enlace al correo <span>{{getPartialMail()}}</span> para validar tu cuenta
        </div>
        <div class="mt-3 text-center">
          <small><i style="font-weight: 100;">Por favor, ingresa a tu casilla y sigue los pasos restantes para finalizar el registro.</i></small>
        </div>
        <br>
        <div class="text-center mb-3 mt-3">
          <small><i style="font-weight: 100;">¿No es tu correo? Click <a href="#" onclick="document.getElementById('call_center').click();">aquí</a> para comunicarte con nosotros</i></small>
        </div>
        <button class="btn btn-primary register-form-input" (click)="backToHome()" type="button" value="Siguiente"> Volver al sitio</button>
      </div>
    </div>
  </div>
</div>

